import { api } from 'API';
import { addImposterToUrl } from 'Utils';
const baseUrl = '/Notifications';

export interface IUserUpdates {
  id: number;
  caseNumber: string;
  createDate: Date;
  shemeshCreateDate: Date;
  title: string;
  description: string;
  notifEntityId: number;
  notifSubjectId: number;
  entityJSON: string;
  readedDate: Date | null;
  filterLabel: string;
}

export interface GeneralItem {
  id: string;
}

export interface MedicalReferralItem extends GeneralItem {
  Subject: string;
  HasFile: boolean;
  Id: string;
}

export interface DocumentItem extends GeneralItem {
  name: string;
}

export interface EntityJSON<T extends GeneralItem> {
  title: string;
  items: T[];
}

export interface UpdateNotifToReadedResponse {
  notifId: number;
  readedDate: Date;
}

export enum NotifSubjectsType {
  MedicalReferrals = 1,
  Documents,
  PaymentsAndDeductions,
}

export enum SubjectType {
  GroupedMedicalRef = 1,
  SingleMedicalRef = 2,
  SingleDocument = 3,
  GroupedPaymentsAndDeductions = 4,
  SinglePaymentsAndDeductions = 5,
}

export const getUpdates = async () => {
  const res = await api.get<IUserUpdates[]>(addImposterToUrl(baseUrl, true));
  if (res) return { status: res.status, data: res?.data };
};

export const setNotifReaded = async (id: number) => {
  const res = await api.patch<UpdateNotifToReadedResponse[]>(
    addImposterToUrl(`${baseUrl}/readed/${id}`, true)
  );
  if (res) return res;
};
